import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import ProfileMenu from "./ProfileMenu";

const jobNameImgUrl = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBdtl1telmsxvfIElHrJR8BUVLgZApsN8bYJRd6HMqiHuNLPxS";
const locationIconUrl = "https://cdn-icons-png.flaticon.com/128/14027/14027590.png";

export default function HRDashboard({ jobs }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [hoveredId, setHoveredId] = useState(null);

  if (!user) return null;

  return (
    <div style={{ background: "#f8f9ff", minHeight: "100vh" }}>
      {/* Sticky Header Row */}
      <div
        style={{
          position: "sticky",
          top: 0,
          left: 0,
          right: 0,
          background: "#fff",
          zIndex: 110,
          borderBottom: "1px solid #f0f1f5",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "24px 40px 18px 40px",
        }}
      >
        <div>
          <div
            style={{
              fontWeight: 700,
              fontSize: "2.5rem",
              marginLeft: 188,
              color: "#172d44",
            }}
          >
            HR Dashboard
          </div>
          <div
            style={{
              color: "#586b87",
              fontSize: 15,
              marginTop: 2,
              marginLeft: 190,
              maxWidth: 300,
            }}
          >
            Manage job applications and candidate reviews
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: 12,
          }}
        >
          <div
            style={{
              fontSize: 20,
              color: "#455e88",
              fontWeight: 600,
              marginRight: 10,
              letterSpacing: "0.01em",
            }}
          >
            Total Jobs:{" "}
            <span style={{ color: "#236ef2", fontWeight: 700 }}>
              {jobs.length}
            </span>
          </div>
          <ProfileMenu />
        </div>
      </div>

      {/* Centered Jobs Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(300px, 1fr))",
          gap: 32,
          justifyContent: "center",
          margin: "48px auto",
          maxWidth: 1200,
          padding: "0 40px"
        }}
      >
        {jobs.map((job) => (
          <div
            key={job.jobid}
            style={{
              background: "#fff",
              borderRadius: 16,
              boxShadow: hoveredId === job.jobid
                ? "0 12px 30px rgba(35,115,240,0.15)"
                : "0 4px 12px rgba(0,0,0,0.03)",
              padding: "32px 28px",
              display: "flex",
              flexDirection: "column",
              transform: hoveredId === job.jobid ? "translateY(-6px)" : "translateY(0)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "1px solid #f1f5f9",
              position: "relative",
              overflow: "hidden"
            }}
            onMouseEnter={() => setHoveredId(job.jobid)}
            onMouseLeave={() => setHoveredId(null)}
          >
            <div style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: 6,
              height: "100%",
              background: "#2373f0",
              opacity: hoveredId === job.jobid ? 1 : 0.6,
              transition: "opacity 0.3s"
            }} />

            <div style={{ display: "flex", alignItems: "flex-start", gap: 14, marginBottom: 12 }}>
              <img
                src={jobNameImgUrl}
                alt=""
                style={{ width: 36, height: 36, objectFit: "contain" }}
              />
              <div>
                <h3 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: "#1e293b" }}>
                  {job.jobrole}
                </h3>
                <div style={{ fontSize: 13, color: "#64748b", fontWeight: 600, marginTop: 2 }}>
                  {job.jobid}
                </div>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#475569", marginBottom: 32, fontSize: 14 }}>
              <img src={locationIconUrl} alt="" style={{ width: 16, height: 16, opacity: 0.7 }} />
              <span style={{ fontWeight: 500 }}>
                {Array.isArray(job.location) ? job.location.join(", ") : job.location}
              </span>
            </div>

            <button
              onClick={() => navigate(`/hr/jobs/${job.jobrole}/${job.location}/${job.jobid}`)}
              style={{
                width: "100%",
                padding: "14px 0",
                fontSize: 15,
                fontWeight: 700,
                background: "#2373f0",
                color: "#fff",
                border: "none",
                borderRadius: 10,
                cursor: "pointer",
                transition: "all 0.2s",
                boxShadow: "0 4px 12px rgba(35,115,240,0.2)"
              }}
              onMouseOver={e => e.currentTarget.style.background = "#1d5ec5"}
              onMouseOut={e => e.currentTarget.style.background = "#2373f0"}
            >
              View Applications
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
